<template>
  <div class="page_israGud">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">版本类型</div>
            <el-select v-model="listQuery.VerType" size="small" placeholder="" clearable @change="searchHandle">
              <el-option label="集团版" value="集团版"></el-option>
              <el-option label="业务版" value="业务版"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <div class="flname">主体公司</div>
            <el-input v-model="listQuery.CompanyName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>信息维护</el-breadcrumb-item>          <el-breadcrumb-item>文档管理</el-breadcrumb-item>
          <el-breadcrumb-item>公司介绍</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="案例管理" name="/successCaseSet"></el-tab-pane>
          <el-tab-pane label="合同模板管理" name="/contractTemplateSet"></el-tab-pane>
          <el-tab-pane label="报价体系" name="/quotationGuiSet"></el-tab-pane>
          <!-- <el-tab-pane label="三体系认证" name="/threeSystem"></el-tab-pane> -->
          <el-tab-pane label="公司介绍" name="/companyProfileSet"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px">
          <el-button type="success" size="small" @click="addCompany('')">&nbsp;新增</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" style="width: 731px;">
          <el-table-column prop="SerialNumber" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="CompanyName" label="公司主体" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="VerType" label="版本类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="UpdataTime1" label="更新时间" width="140" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.UpdataTime1 ? scope.row.UpdataTime1.split('T')[0] : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="Manager" label="管理员" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.ManagerId)" v-show="row.ManagerId && row.Manager" title="点击查看联系方式">{{row.Manager}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="AttachmentUrl" label="附件" width="100" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div class="info_item_sys cp" v-if="scope.row.AttachmentUrl" @click="down(scope.row.AttachmentUrl,scope.row.AttachmenFileName)">{{ scope.row.AttachmenFileName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <span class="info_item_sys cp" @click="addCompany(scope.row)">编辑</span>
              <span class="info_item_sys cp" style="margin-left: 10px;" @click="del(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        tableHeight: 0,
        listQuery: {
          CompanyName: '',
          VerType: '',
          pageNum: 1,
          pageSize: "10"
        },
        activeName:'/companyProfileSet',
        totalCount:0,
        tableData: [],
        headPath: this.$store.state.EMP.docPath,
        gridData:[],
        gridloading:false
      };
    },
    created() {
      this.calHeight();
      this.getcompIntroducelist();
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      //获取公司介绍列表
      getcompIntroducelist() {
        xz.getcompIntroducelist(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getcompIntroducelist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getcompIntroducelist();
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      searchHandle() {
        this.getcompIntroducelist();
      },
      handleClick(){
        this.$router.push({
          path:this.activeName
        })
      },
      //查看详情
      toDdetail() {
        this.$router.push({
          path: '/legalSubjectInfo'
        })
      },
      addCompany(row){
        this.$router.push({
          path: "/addCompanyProfile",
          query: {
            row: row ? JSON.stringify(row) : ''
          },
        });
      },
      down(url,name) {
        let d = url.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.setAttribute('download', name);
        aTag.click();
      },
      del(row) {
        this.$set(row, 'IsDeleted', 1)
        xz.updatecompIntroduce(row).then(res => {
          if (res.status == 'ok') {
            this.searchHandle()
            this.$message.success('删除成功')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      getPhone(id){
        this.gridloading = true;
        let dtlQuery = {
          mainuserid:'',
          useridr: id
        }
        xz.getauthJbUserDetail(dtlQuery).then(res=>{
          if(res.status=='ok'){
            this.gridData = [{
              phone:res.msg.Strmobile
            }]
            this.gridloading = false;
          }else{
            this.$message.error('获取联系方式失败')
            this.gridData = []
            this.gridloading = false;
          }
        })
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }
</style>
<style>
  .page_israGud .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_israGud .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_israGud .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_israGud .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_israGud .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_israGud .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_israGud .screenInputs .screenInput .el-select .el-input__inner,
  .page_israGud .re_down_form.el-form--inline .el-form-item__content,
  .page_israGud .re_down_form .el-select,
  .page_israGud .re_down_form .el-form-item__content,
  .page_israGud .screenInput .el-input {
    width: 200px !important;
  }

  /* .doc_table.el-table .cell {
    padding: 0 5px;
  } */

  .page_israGud .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_israGud .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }


  .page_israGud .r_dropDownScreen .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
</style>